// extracted by mini-css-extract-plugin
export default {"formLink":"Login_formLink__osXPl","subMenu":"Login_subMenu__ZBMf3"};